export * from '@fhs/routing/src/routes/cart/payment';
export { default } from '@fhs/routing/src/routes/cart/payment/index';
